var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 13.8223V3.9375C9.84375 3.56836 10.1309 3.28125 10.5 3.28125C10.8691 3.28125 11.1562 3.56836 11.1562 3.9375V13.8223H9.84375ZM9.84375 15.1143H11.1562V16.3447H9.84375V15.1143ZM0 10.5C0 4.69629 4.69629 0 10.5 0C16.3037 0 21 4.69629 21 10.5C21 16.3037 16.3037 21 10.5 21C4.69629 21 0 16.3037 0 10.5ZM19.708 10.5C19.708 5.43457 15.5654 1.3125 10.5 1.3125C5.43457 1.3125 1.3125 5.43457 1.3125 10.5C1.3125 15.5654 5.43457 19.6875 10.5 19.6875C15.5654 19.6875 19.708 15.5654 19.708 10.5Z",
    fill: "url(#paint0_linear_646_8769)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_646_8769",
    x1: 0,
    y1: 10.5,
    x2: 21,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationFailed);
export default __webpack_public_path__ + "static/media/Verification Failed.fbed932a2a051a350ae0849f0a967b54.svg";
export { ForwardRef as ReactComponent };